import axios from "../api/axios";

export type PaymentStatus = "paid" | "waiting" | "verifying" | "expired" | "cancelled" | "not_ready";

export interface PendingPayment {
  teleconsult_id: number;
  teleconsult_status: string;
  stage: string | null;
  payment_status: PaymentStatus;
  doctor_name: string | null;
  doctor_avatar_url: string | null;
  total: number | null;
  payment_method: string | null;
  payment_code: string | null;
  va: string | null;
  payment_url: string | null;
  has_gateway_payment: boolean;
  can_create_payment: boolean;
  base_deadline: string | null;
  expired_date: string | null;
  remaining_seconds: number;
  server_time: string;
  enc_token: string | null;
}

export const getPendingPayment = async (token: string) => {
  const res = await axios.get("teleconsult/pending-payment", {
    headers: { Authorization: `Bearer ${token}` },
  });

  return (res.data.data ?? null) as PendingPayment | null;
};

export const getPaymentStatus = async (teleconsultId: string | number, token: string) => {
  const res = await axios.get(`teleconsult/${teleconsultId}/payment-status`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data.data as PendingPayment;
};

export const cancelPendingPayment = async (teleconsultId: string | number, token: string) => {
  const res = await axios.post(`teleconsult/${teleconsultId}/cancel-payment`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data;
};
